require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-financial-center-first-cu-predictive-analytics-receiving-national-attention.json") })
        }
      }, "path---articles-financial-center-first-cu-predictive-analytics-receiving-national-attention");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-financial-center-first-cu-predictive-analytics-receiving-national-attention!./.cache/json/articles-financial-center-first-cu-predictive-analytics-receiving-national-attention.json
// module id = 1629
// module chunks = 231608221292675